import { useEffect, useRef } from 'react';

/**
 * 포그라운드 판별 없이, 컴포넌트가 마운트되어 있고 delay가 null이 아닌 동안
 * 항상 동작하는 setInterval 래퍼.
 * - delay가 null이면 비활성화 (interval 정지), 기본값 1000ms
 *
 * `useForegroundInterval`과 달리 화면 visibility/foreground를 따지지 않는다.
 * 다음과 같이 foreground 판별이 불필요하거나 부정확한 경우에 사용한다:
 * - 사용자가 보고 있는 동안 무조건 돌아야 하는 타이머(카운트다운 등)
 * - raw react-native `<Modal>` 내부처럼 부모 surface가 background로 오판별되어
 *   `useForegroundInterval`이 interval을 시작조차 못 하는 경우
 *
 * "화면이 안 보일 때 멈춰야 하는" 인터벌(자동 스크롤, 폴링, DISPLAY 로깅 등)은
 * 이 훅 대신 `useForegroundInterval`을 사용할 것.
 */
export const useInterval = (
  callback: () => void,
  delay: number | null = 1000,
) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (delay === null) return;

    // eslint-disable-next-line no-restricted-globals -- setInterval 허용 래퍼
    const id = setInterval(() => callbackRef.current(), delay);
    return () => clearInterval(id);
  }, [delay]);
};
